var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40010888_14449)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40010888_14449",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40010888_14449)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_40010888_14449",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H40V40H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_40010888_14449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8281 40C39.1603 40 39.4768 39.8591 39.699 39.6122C39.9213 39.3654 40.0283 39.0358 39.9935 38.7054L38.431 23.8617C38.3682 23.2653 37.8653 22.8125 37.2656 22.8125H24.7656C24.1659 22.8125 23.6629 23.2653 23.6002 23.8617L22.0377 38.7054C22.0029 39.0358 22.1099 39.3654 22.3322 39.6122C22.5544 39.8591 22.871 40 23.2031 40H38.8281ZM25.8206 25.1563H36.2106L37.5264 37.6562H24.5048L25.8206 25.1563Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1094 21.25V26.3281C27.1094 26.9753 27.634 27.5 28.2812 27.5C28.9285 27.5 29.4531 26.9753 29.4531 26.3281V21.25C29.4531 20.387 30.1527 19.6875 31.0156 19.6875C31.8786 19.6875 32.5781 20.387 32.5781 21.25V26.3281C32.5781 26.9753 33.1028 27.5 33.75 27.5C34.3972 27.5 34.9219 26.9753 34.9219 26.3281V21.25C34.9218 19.0926 33.173 17.3438 31.0156 17.3438C28.8583 17.3438 27.1094 19.0926 27.1094 21.25Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 16.7969C20.3125 19.6014 18.039 21.875 15.2344 21.875C12.4298 21.875 10.1562 19.6014 10.1562 16.7969V12.1094C10.1563 11.4621 10.6809 10.9375 11.3281 10.9375H19.1406C19.7878 10.9375 20.3125 11.4621 20.3125 12.1094V16.7969ZM22.6562 12.1094C22.6562 10.1677 21.0823 8.59373 19.1406 8.59373H11.3281C9.38647 8.59373 7.81251 10.1677 7.8125 12.1094V16.7969C7.8125 20.8959 11.1354 24.2188 15.2344 24.2188C19.3334 24.2187 22.6562 20.8959 22.6562 16.7969V12.1094Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 14.4531C25 15.1004 24.4754 15.625 23.8281 15.625H22.6562V13.2812H23.8281C24.4754 13.2812 25 13.8059 25 14.4531ZM27.3438 14.4531C27.3438 12.5115 25.7698 10.9375 23.8281 10.9375H21.4844C20.8372 10.9375 20.3125 11.4622 20.3125 12.1094V16.7969C20.3125 17.4441 20.8372 17.9688 21.4844 17.9688H23.8281C25.7698 17.9688 27.3438 16.3948 27.3438 14.4531Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98438 17.9688C9.63158 17.9688 10.1562 17.4441 10.1562 16.7969V12.1094C10.1562 11.4622 9.63158 10.9375 8.98438 10.9375H6.64062C4.69896 10.9375 3.125 12.5115 3.125 14.4531C3.125 16.3948 4.69896 17.9687 6.64062 17.9688H8.98438ZM5.46875 14.4531C5.46875 13.8059 5.99338 13.2812 6.64062 13.2812H7.8125V15.625H6.64062C5.99338 15.625 5.46875 15.1004 5.46875 14.4531Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 8.20218V12.252C4.6875 12.8992 5.21217 13.4238 5.85938 13.4238C6.50658 13.4238 7.03125 12.8992 7.03125 12.252V8.20218C7.03126 4.96611 9.65456 2.3428 12.8906 2.3428C14.6655 2.3428 16.3926 2.91848 17.8125 3.98337L18.4374 4.45212L18.4566 4.46619C18.6557 4.60936 18.895 4.68655 19.1406 4.68655H20.7031C22.2132 4.68655 23.4375 5.91081 23.4375 7.42094V12.252C23.4375 12.8992 23.9622 13.4238 24.6094 13.4238C25.2566 13.4238 25.7812 12.8992 25.7812 12.252V7.42094C25.7812 4.61639 23.5077 2.3428 20.7031 2.3428H19.5313L19.2188 2.10843L19.2188 2.10837C17.3932 0.739194 15.1726 -0.00094986 12.8906 -0.00094986C8.36014 -0.00094986 4.68751 3.67169 4.6875 8.20218Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 22.2039V25.5469C17.1875 26.6256 16.3131 27.5 15.2344 27.5C14.1557 27.5 13.2813 26.6255 13.2812 25.5469V22.2039C13.2812 21.5567 12.7566 21.032 12.1094 21.032C11.4622 21.032 10.9375 21.5567 10.9375 22.2039V25.5469C10.9375 27.9199 12.8612 29.8437 15.2344 29.8438C17.6075 29.8438 19.5313 27.9199 19.5313 25.5469V22.2039C19.5313 21.5567 19.0066 21.032 18.3594 21.032C17.7122 21.032 17.1875 21.5567 17.1875 22.2039Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 34.9219V38.8281C0 39.4753 0.524666 40 1.17188 40H23.2031C23.8503 40 24.375 39.4753 24.375 38.8281C24.375 38.1809 23.8503 37.6562 23.2031 37.6562H2.34375V34.9219C2.34376 30.3914 6.01643 26.7187 10.5469 26.7187H12.1094C12.7566 26.7187 13.2813 26.1941 13.2813 25.5469C13.2813 24.8997 12.7566 24.375 12.1094 24.375H10.5469C4.72202 24.375 1.04341e-05 29.097 0 34.9219Z",
    fill: "#D2042D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9067 27.7501C24.4721 28.0651 25.1858 27.862 25.5007 27.2966C25.8157 26.7312 25.6126 26.0175 25.0472 25.7025C23.529 24.8568 21.7803 24.3746 19.9219 24.3746H18.3594C17.7122 24.3746 17.1875 24.8993 17.1875 25.5465C17.1875 26.1937 17.7122 26.7184 18.3594 26.7184H19.9219C21.3702 26.7184 22.7276 27.0933 23.9067 27.7501Z",
    fill: "#D2042D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40010888_14449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyer);
export default __webpack_public_path__ + "static/media/buyer.97b1c36bc4fe1c1ba5a5e5301343bcc2.svg";
export { ForwardRef as ReactComponent };